{
  "language": {
    "label": "Idioma"
  },
  "common": {
    "next": "Siguiente",
    "previous": "Anterior",
    "cancel": "Cancelar",
    "save": "Guardar",
    "finish": "Finalizar",
    "loading": "Cargando...",
    "home": "Inicio",
    "numbersOnly": "Ingrese solo números",
    "cancelRegistration": "Cancelar registro",
    "smartdocsPortal": "@ Smartdocs Portal",
    "noVersionInfo": "No hay información de versión del sistema.",
    "portalDeServicos": "Portal de Servicios",
    "catalog": "Catálogo",
    "requests": "Solicitudes"
  },
  "login": {
    "title": "Ingresar al Portal de Servicios",
    "passwordLabel": "Contraseña *",
    "saveCredentials": "Guardar datos para accesos futuros",
    "recaptchaError": "No fue posible validar su envío. Por favor, actualice la página e intente nuevamente.",
    "submitting": "Ingresando...",
    "submit": "Ingresar con CPF",
    "forgotPassword": "Olvidé la contraseña",
    "noAccount": "Aún no tengo cuenta",
    "loginError": "Error al iniciar sesión.",
    "loginErrorTitle": "Error al iniciar sesión:",
    "tooManyAttempts": "Múltiples intentos incorrectos. Su acceso ha sido bloqueado temporalmente por 15 minutos."
  },
  "forgotPassword": {
    "title": "Olvidé la contraseña",
    "submitButton": "ENVIAR ENLACE DE RESTABLECIMIENTO",
    "successTitle": "¡Enlace para nueva contraseña enviado con éxito!",
    "successMessage": "Se envió un enlace para crear una nueva contraseña al correo electrónico registrado.",
    "registeredEmailLabel": "Correo electrónico registrado *",
    "accessEmail": "Acceda a este correo para realizar el cambio."
  },
  "resetPassword": {
    "title": "Crear nueva contraseña",
    "subtitle": "¿Qué contraseña desea utilizar para ingresar al portal?",
    "keepPassword": "Guarde su contraseña en un lugar seguro y accesible.",
    "keepPasswordTypo": "Guarde su contraseña en un lugar seguro y accesible.",
    "passwordLabel": "Contraseña *",
    "confirmPasswordLabel": "Repetir Contraseña *",
    "saveButton": "Guardar nueva contraseña",
    "successTitle": "¡Contraseña cambiada con éxito!",
    "expiredTitle": "¡El enlace ha expirado!",
    "expiredMessage": "El enlace para restablecer la contraseña ha expirado.",
    "requestNewLink": "Solicite un nuevo enlace de restablecimiento.",
    "enterPortal": "Ingresar al portal"
  },
  "emailValidation": {
    "accountReady": "¡Su cuenta está lista para usar!",
    "emailMainChannel": "El correo electrónico es el principal canal de comunicación entre el Portal y usted.",
    "checkInbox": "Revise su bandeja de entrada regularmente.",
    "enterPortal": "INGRESAR AL PORTAL",
    "validateEmail": "Valide su correo electrónico para liberar el acceso.",
    "requestNewLink": "Solicite un nuevo enlace de validación.",
    "emailNotValidated": "Su correo electrónico aún no ha sido validado.",
    "indispensableStep": "Este paso es indispensable para liberar su acceso al portal.",
    "resendButton": "REENVIAR CORREO DE VALIDACIÓN",
    "linkExpires": "El enlace del correo expira en 1 hora.",
    "linkSentSuccess": "¡Enlace enviado con éxito!",
    "almostThere": "¡Ya casi estamos!",
    "accessEmailToValidate": "Acceda al correo enviado por el Portal y abra el enlace de validación para activar su cuenta.",
    "indispensableStepPortal": "Este paso es indispensable para liberar su acceso al portal.",
    "accessRegistrationEmail": "Acceda al correo utilizado en el registro y realice la validación."
  },
  "register": {
    "createAccount": "Crear cuenta",
    "abandonTitle": "¿Desea abandonar el registro?",
    "abandonMessage": "Al salir, perderá todos los datos ingresados hasta ahora.",
    "continueRegistering": "Continuar registrando",
    "exitRegistration": "Salir del registro",
    "steps": {
      "cpf": "¿Cuál es su CPF?",
      "fullName": "¿Cuál es su nombre completo?",
      "contacts": "¿Cuáles son sus datos de contacto?",
      "address": "¿Cuál es su dirección?",
      "password": "¿Qué contraseña desea utilizar para ingresar al portal?"
    },
    "cpfAlreadyRegistered": "El CPF ingresado ya está registrado. Por favor, ingrese un CPF diferente.",
    "serviceUnavailable": "Servicio no disponible, intente nuevamente más tarde.",
    "fullNameLabel": "Nombre completo *",
    "fullNamePlaceholder": "Nombre Apellido",
    "emailLabel": "Correo electrónico *",
    "emailHelperText": "Elija una dirección de correo electrónico de fácil acceso para usted.",
    "confirmEmailLabel": "Repetir correo electrónico *",
    "confirmEmailHelperText": "El correo electrónico debe ser idéntico al informado arriba.",
    "confirmPasswordLabel": "Repetir contraseña *",
    "confirmPasswordHelperText": "La contraseña debe ser idéntica a la informada arriba.",
    "acceptTerms": "Acepto los",
    "consentTerms": "Términos de Consentimiento",
    "cepRequired": "El código postal es obligatorio para avanzar.",
    "cepDigits": "El código postal debe tener 8 dígitos para avanzar.",
    "cepInvalid": "Código postal inválido. Puede completar la dirección manualmente.",
    "ufLabel": "Estado",
    "cityLabel": "Ciudad *",
    "neighborhoodLabel": "Barrio *",
    "streetLabel": "Calle *",
    "streetNumberLabel": "Número *",
    "complementLabel": "Complemento",
    "cellphoneLabel": "Teléfono celular *",
    "phoneLabel": "Teléfono fijo",
    "returnSuccess": {
      "title": "¡Cuenta creada con éxito!",
      "almostThere": "¡Ya casi estamos!",
      "emailSent": "Se envió un correo electrónico a la dirección proporcionada durante la creación de la cuenta.",
      "emailLabel": "Correo electrónico informado *",
      "validateAccess": "Acceda a este correo para validar su registro y acceder al portal.",
      "redirecting": "Redirigiendo en {{countdown}} seg o",
      "clickHere": "haga clic aquí."
    },
    "returnError": {
      "title": "Elija otro correo para el registro",
      "message": "No pudimos enviar el enlace de validación al correo electrónico informado",
      "emailLabel": "Correo electrónico informado *",
      "chooseAnother": "Elija <b>otra</b> dirección de <b>correo electrónico</b> a la que tenga <b>fácil acceso</b>.",
      "emailFieldLabel": "Correo electrónico *",
      "confirmEmailLabel": "Repetir correo electrónico *"
    }
  },
  "home": {
    "catalog": "Catálogo",
    "requests": "Solicitudes",
    "noRequests": "Aún no ha realizado solicitudes.",
    "noCategory": "Ninguna categoría encontrada.",
    "noOrganization": "Ninguna unidad encontrada.",
    "noService": "Ningún servicio encontrado.",
    "others": "Otros",
    "startRequest": "Iniciar solicitud",
    "searchPlaceholder": "Buscar una solicitud",
    "searchTitle": "Acompañe sus solicitudes",
    "searchOrganizationPlaceholder": "Buscar una unidad",
    "searchOrganizationTitle": "Elija una unidad",
    "searchCategoryPlaceholder": "Buscar una categoría",
    "searchCategoryTitle": "Elija una categoría",
    "searchServicePlaceholder": "Buscar un servicio",
    "searchServiceTitle": "Elija un servicio",
    "noTaskFound": "Ninguna tarea encontrada"
  },
  "myAccount": {
    "title": "Mi cuenta",
    "fullNameLabel": "Nombre completo",
    "cpfLabel": "CPF",
    "editPassword": "Editar contraseña",
    "logout": "Cerrar sesión y salir",
    "logoutDialogTitle": "¿Desconectar del portal?",
    "logoutDialogMessage": "Cerrar sesión y salir con seguridad.",
    "logoutButton": "Desconectar",
    "stayButton": "Permanecer en el Portal",
    "deactivateAccount": "Desactivar cuenta",
    "deactivateModalTitle": "Desactivar cuenta permanentemente",
    "deactivateModalWarning": "Atención: esta acción es irreversible. Al desactivar su cuenta, sus datos personales serán eliminados y ya no podrá acceder al portal con este registro.",
    "deactivateModalSubtitle": "Ingrese el motivo y su contraseña para confirmar la desactivación permanente de la cuenta.",
    "deactivationReasonLabel": "Motivo de la desactivación *",
    "deactivationReasonPlaceholder": "Describa el motivo de la desactivación...",
    "deactivationPasswordLabel": "Su contraseña actual *",
    "proceedButton": "Continuar",
    "confirmDeactivationButton": "Confirmar desactivación",
    "deactivatingButton": "Desactivando...",
    "deactivateSuccess": "Cuenta desactivada con éxito.",
    "deactivateErrorTitle": "Error al desactivar la cuenta",
    "deactivateError": "Error al desactivar la cuenta. Verifique su contraseña e intente nuevamente."
  },
  "editPassword": {
    "breadcrumb": "Mi cuenta",
    "title": "Editar contraseña",
    "currentPasswordLabel": "Contraseña actual *",
    "passwordLabel": "Contraseña *",
    "confirmPasswordLabel": "Repetir nueva contraseña *",
    "cancelButton": "Cancelar",
    "saving": "Guardando...",
    "saveButton": "Guardar edición",
    "successMessage": "¡Contraseña actualizada con éxito!",
    "errorMessage": "Error al actualizar la contraseña. Intente nuevamente.",
    "incorrectPassword": "La contraseña es incorrecta."
  },
  "requestHistory": {
    "breadcrumbRequests": "Solicitudes",
    "historyTitle": "Historial de la solicitud",
    "stepsTab": "Etapas",
    "documentsTab": "Documentos",
    "orderByLabel": "Ordenar por",
    "mostRecent": "Más recientes",
    "oldest": "Más antiguos",
    "documentsLoadError": "Error al cargar los documentos.",
    "noDocuments": "El proceso aún no tiene documentos.",
    "processStarted": "Proceso iniciado",
    "inProgress": "En curso",
    "completed": "Completada"
  },
  "signature": {
    "signSuccess": "¡Documento(s) firmado(s) con éxito!",
    "signError": "Error al firmar documento(s): ",
    "otpResent": "OTP reenviado.",
    "otpResendError": "Error al reenviar OTP:",
    "modalTitle": "Firmar documento(s) seleccionado(s)",
    "modalDescription": "Use el código recibido por correo electrónico para firmar el/los documento(s).",
    "emailLabel": "Correo electrónico *",
    "codeLabel": "Código *",
    "codePlaceholder": "Código",
    "signAndSend": "Firmar y enviar",
    "returnToDocuments": "Volver a los documentos",
    "resendOtpTitle": "Reenviar código de firma (OTP)",
    "resendOtpDescription": "El código será enviado al firmante registrado y, si se agregó, también al correo electrónico indicado abajo",
    "additionalEmailLabel": "Correo electrónico adicional (opcional)",
    "emailPlaceholder": "Correo electrónico",
    "resendOtpButton": "Reenviar OTP"
  },
  "errors": {
    "pageNotFound": "NO ENCONTRAMOS ESTA PÁGINA",
    "backToHome": "Volver al inicio",
    "weApologize": "¡PEDIMOS DISCULPAS!",
    "underMaintenance": "ESTAMOS TEMPORALMENTE EN MANTENIMIENTO",
    "somethingWentWrong": "ALGO SALIÓ MAL"
  },
  "toast": {
    "userNotFound": "¡Usuario no encontrado!",
    "accessDenied": "¡Acceso denegado!",
    "emailInUse": "El correo electrónico ya está en uso",
    "emailNeedsVerification": "¡El correo electrónico necesita ser verificado!",
    "userDisabled": "Usuario deshabilitado.",
    "tokenNotFound": "Confirmación del token no encontrada.",
    "tokenExpired": "Confirmación del token expirada.",
    "incorrectCurrentPassword": "Contraseña actual incorrecta.",
    "incorrectCredentials": "Credenciales incorrectas.",
    "unexpectedError": "Ocurrió un error inesperado. Inténtelo de nuevo más tarde."
  },
  "validation": {
    "cpfRequired": "El CPF es obligatorio para avanzar.",
    "cpfLength": "El CPF debe contener 11 números.",
    "cpfInvalid": "CPF inválido. Revise los datos.",
    "cnpjInvalid": "CNPJ inválido",
    "passwordRequired": "La contraseña es obligatoria para avanzar.",
    "passwordRequiredMasc": "La contraseña es obligatoria para avanzar.",
    "requiredField": "Campo obligatorio",
    "invalidBirthDate": "Fecha de nacimiento inválida",
    "cpfRequiredShort": "CPF es obligatorio.",
    "fullNameRequired": "El nombre completo es obligatorio para avanzar.",
    "emailInvalid": "Correo electrónico inválido",
    "emailRequired": "El correo electrónico es obligatorio para avanzar",
    "emailsMustMatch": "Los correos electrónicos no son idénticos.",
    "confirmEmailRequired": "Repetir correo electrónico es obligatorio para avanzar.",
    "confirmPasswordRequired": "Repetir contraseña es obligatorio para avanzar.",
    "cellphoneRequired": "El teléfono celular es obligatorio para avanzar",
    "cellphoneInvalid": "Este no es un teléfono celular válido",
    "termsRequired": "Para continuar, es necesario aceptar los Términos de Consentimiento",
    "passwordsMustMatch": "Las contraseñas no son idénticas."
  },
  "password": {
    "requirements": "La contraseña debe contener:",
    "minMax": "De 8 a 16 dígitos",
    "uppercase": "Letras MAYÚSCULAS",
    "lowercase": "Letras minúsculas",
    "digits": "Números",
    "special": "Caracteres especiales (@ ; # $ , . etc)",
    "required": "La contraseña es obligatoria para avanzar."
  },
  "fullName": {
    "invalidName": "Este no es un nombre válido.",
    "requirements": "El nombre completo debe contener al menos:",
    "firstName": "01 Nombre propio de 02 letras",
    "lastName": "01 Apellido de 02 letras",
    "otherNames": "Otro(s) nombre(s) con 02 letras o más",
    "noAbbreviation": "No abrevie su nombre."
  },
  "document": {
    "cpfLabel": "CPF *"
  }
}
